<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="page">
	<div class="page-header">
		<div class="back">
			<globalictcc-button
				label="Back to toolbox"
				[textOnly]="true"
				iconName="arrow-left"
				(handleClick)="onGoBack()"
			/>
		</div>

		<div class="page-title">
			<span class="page-name">Anomalies detection</span>
		</div>
	</div>

	<div class="top-actions">
		<form
			[formGroup]="timePeriodFormGroup"
			class="time-actions"
		>
			<globalictcc-datepicker
				label="Time period"
				formControlName="timePeriod"
			/>

			<globalictcc-button
				label="Apply"
				[disabled]="timePeriodFormGroup.invalid"
				(handleClick)="onFilterApply()"
			/>
		</form>
	</div>

	<div class="filter-pagination">
		<globalictcc-popover>
			<globalictcc-button
				popover-trigger
				label="Filter"
				[textOnly]="true"
				iconName="filter"
			/>

			<div
				popover-template
				class="popover-content"
			>
				<span class="popover-title">Filter</span>

				<form [formGroup]="filterFormGroup">
					<globalictcc-dropdown
						label="Application"
						class="fill"
						formControlName="applications"
						[multi]="true"
						[options]="applicationOptions"
					/>

					<globalictcc-button
						label="Apply"
						[disabled]="filterFormGroup.invalid"
						type="submit"
						(handleClick)="onFilterApply()"
					/>
				</form>
			</div>
		</globalictcc-popover>

		<globalictcc-pagination
			[currentPage]="currentPage"
			[totalItems]="totalItems"
			[pageSize]="pageSize"
			[totalPages]="totalPages"
			[pageItems]="pageItems"
			(handlePreviousPage)="onPreviousPage()"
			(handleNextPage)="onNextPage()"
		/>
	</div>

	<globalictcc-table
		[gridOptions]="gridOptions"
		[hasError]="anomaliesTableHasError"
		(handleTableRefresh)="fetchAnomalies()"
	/>

	<div class="bottom-actions">
		<globalictcc-button
			label="Download as CSV"
			[textOnly]="true"
			iconName="download"
		/>
	</div>
</section>
